export const formatarData = (iso) => {
    if (!iso) return "—";
    const [ano, mes, dia] = String(iso).slice(0, 10).split("-");
    return `${dia}/${mes}/${ano}`;
};

export const formatarDataHora = (iso) => {
    if (!iso) return "—";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return String(iso);
    return d.toLocaleString("pt-BR");
};

export const formatarMoeda = (valor) =>
    valor === null || valor === undefined ? "—" : Number(valor).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

/** Indicador visual por fase do ciclo de vida. */
export const FASE_ESTILO = {
    EM_ESTOQUE: "bg-sky-100 text-sky-800",
    DISPONIVEL: "bg-emerald-100 text-emerald-800",
    EM_USO: "bg-indigo-100 text-indigo-800",
    EM_MANUTENCAO: "bg-amber-100 text-amber-800",
    EMPRESTADO: "bg-violet-100 text-violet-800",
    INATIVO: "bg-slate-200 text-slate-700",
    BAIXADO: "bg-red-100 text-red-800",
    DESCARTADO: "bg-zinc-300 text-zinc-800",
};

/** Cor de cada tipo de movimentação na linha do tempo. */
export const MOVIMENTACAO_ESTILO = {
    CADASTRO: "bg-emerald-500",
    ALTERACAO_CADASTRAL: "bg-slate-400",
    TRANSFERENCIA_FILIAL: "bg-sky-500",
    MUDANCA_DEPARTAMENTO: "bg-sky-400",
    TROCA_RESPONSAVEL: "bg-indigo-500",
    ALTERACAO_LOCALIZACAO: "bg-teal-500",
    VINCULO_EQUIPAMENTO: "bg-cyan-500",
    ALTERACAO_STATUS: "bg-blue-500",
    EMPRESTIMO: "bg-violet-500",
    DEVOLUCAO: "bg-violet-400",
    MANUTENCAO: "bg-amber-500",
    BAIXA: "bg-red-500",
    DESCARTE: "bg-zinc-700",
    ANEXO: "bg-pink-400",
};

const CAMPO_EXIBICAO = {
    tipoDispositivoId: "tipoDispositivoNome",
    marcaId: "marcaNome",
    modeloId: "modeloNome",
    operadoraId: "operadoraNome",
    statusId: "statusNome",
    filialId: "filialNome",
    departamentoId: "departamentoNome",
    equipamentoPrincipalId: "equipamentoPrincipalDescricao",
    proprietario: "proprietarioRotulo",
    tipoComputador: "tipoComputadorRotulo",
    estadoConservacao: "estadoConservacaoRotulo",
};

/** Valor legível de um campo do ativo conforme sua definição (nomes no lugar de ids). */
export function exibirCampo(ativo, def) {
    const chaveExibicao = CAMPO_EXIBICAO[def.chave];
    const bruto = chaveExibicao ? ativo[chaveExibicao] : ativo[def.chave];
    if (bruto === null || bruto === undefined || bruto === "") return "—";
    if (def.tipo === "DATA") return formatarData(bruto);
    if (def.tipo === "DECIMAL") return formatarMoeda(bruto);
    return String(bruto);
}

/** Campos condicionais só existem quando a condição da definição é satisfeita. */
export function campoVisivel(def, valores) {
    if (!def.visivelSeCampo) return true;
    const ref = valores[def.visivelSeCampo];
    return ref !== null && ref !== undefined && String(ref) === def.visivelSeValor;
}

export function vazio(v) {
    return v === null || v === undefined || (typeof v === "string" && v.trim() === "");
}

/** Identificador do ativo a partir de um código de inventário (TI-000123); nulo se o texto não for um código. */
export function idDoCodigoInventario(texto) {
    const m = /^TI-?0*(\d{1,15})$/i.exec((texto || "").trim());
    return m ? Number(m[1]) : null;
}

/** Data de hoje no formato yyyy-MM-dd (fuso local), para campos de data. */
export function hojeIso() {
    const d = new Date();
    const mes = String(d.getMonth() + 1).padStart(2, "0");
    const dia = String(d.getDate()).padStart(2, "0");
    return `${d.getFullYear()}-${mes}-${dia}`;
}

/** Campos de endereço MAC do ativo (usam máscara AA:BB:CC:DD:EE:FF). */
export const CAMPOS_MAC = ["mac", "macWifi"];

/** Aplica a máscara de MAC: só hexadecimais, maiúsculas, pares separados por ":" (aceita colar com - ou .). */
export function mascaraMac(valor) {
    const hex = String(valor ?? "").replace(/[^0-9a-fA-F]/g, "").toUpperCase().slice(0, 12);
    return (hex.match(/.{1,2}/g) || []).join(":");
}

/** MAC completo (12 dígitos hexadecimais) ou vazio. */
export function macCompleto(valor) {
    const v = String(valor ?? "").trim();
    return v === "" || v.replace(/[^0-9a-fA-F]/g, "").length === 12;
}
